import Modal from "../../../elements/Modal";
import AllMediaList from "./AllMediaList";

const SelectedMedia = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
  onSelect = () => {},
  selectedData,
  isSingle,
}) => {
  return (
    <>
      <Modal
        isOpen={open}
        setIsOpen={() => {
          close();
        }}
        title={"Select Media"}
        size="xl8"
        modaltitleClasses={"!text-slate-200 text-[15px]"}
        headerclassName={""}
        titleIcon={"titleIcon"}
        subtitle={"Create a new folder to organize your files."}
      >
        <div className="space-y-4 w-full flex flex-col pb-10">
          <AllMediaList
            onSelect={onSelect}
            close={close}
            selectedData={selectedData}
            isSingle={isSingle}
          />
        </div>
      </Modal>
    </>
  );
};

export default SelectedMedia;
